import isEqual from 'fast-deep-equal';

export function areObjectsEqual<T>(a: T, b: T): boolean {
  return isEqual(a, b);
}
